/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpLeftIcon16Solid = forwardRef('ArrowAUpLeftIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M10.5 2.25a1.25 1.25 0 1 1 0 2.5H6.518l6.866 6.866a1.25 1.25 0 0 1-1.768 1.768L4.75 6.518V10.5a1.25 1.25 0 1 1-2.5 0v-6A2.25 2.25 0 0 1 4.5 2.25h6Z" })));
});
